import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { IUserMonitoringModel } from 'models/monitoring.model'
import api from '../..'
import { applyFilters } from '../../../helpers/filterData.helper'

export const getMonitoring = (
  courseId: number,
  page: number,
  sort: any[],
  searchText: string,
  filterData?: IFilterData
) => {
  const order = sort.map(({ key, order }) => `${key} ${order}`).join(', ')
  const g = applyFilters(filterData)
  return api
    .get(`administration/monitoring/${courseId}`, {
      params: {
        page,
        order,
        search: searchText,
        q: {
          g,
        },
      },
    })
    .then(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

const mapMonitoringAttachments = (attachments: any) => {
  const files = [] as any[]

  if (!attachments) return files

  attachments.forEach((fileArray: any) => {
    fileArray?.data?.forEach(
      ({ attributes: { id, fileUrl, updatedAt, filename, size } }: any) => {
        files.push({ id, fileUrl, updatedAt, filename, size })
      }
    )
  })

  return files
}

export const getUserMonitoring = (courseId: number, userId: number) => {
  return api.get(`administration/monitoring/${courseId}/users/${userId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): IUserMonitoringModel => {
      const {
        conversationId,
        name,
        lastname,
        email,
        identifier,
        position,
        avatar,
        finish,
        pending,
        total,
        supName,
        supLastname,
        startDate,
        finishDate,
        lmsProfileType,
        advance,
        area,
        lmsProfiles,
        enrol,
        access,
        evauationsApproved,
        evauationsReprobate,
        evauationsTotal,
        evaluationsResults,
        synchronousCourseEnrol,
        manuallyAssigned,
        imported,
        evaluations = [],
        approved,
        evaluationState,
      } = attributes

      const attachments = enrol?.data?.attributes?.attachments
      const isAdmin = access?.admin ?? false
      const files = mapMonitoringAttachments(attachments)

      return {
        conversationId,
        name,
        lastname,
        identifier,
        email,
        avatar,
        isAdmin,
        enterprise: {
          position,
          area,
        },
        course: {
          startDate,
          finishDate,
          lmsProfiles,
          lessons: {
            pending,
            finish,
            total,
          },
          evaluations: {
            approved: evauationsApproved,
            failed: evauationsReprobate,
            total: evauationsTotal,
            order: evaluationsResults,
          },
          mandatory: lmsProfileType,
          advance,
          imported,
        },
        others: {
          supName,
          supLastname,
        },
        files,
        synchronousCourseEnrol,
        manuallyAssigned,
        evaluations,
        approved,
        evaluationState,
      }
    }
  )
}
